import React from 'react';

export const OrderHeader = ({ onFromDateClick, onToDateClick, sortConfig }) => {
  const getArrowClass = (key, isAsc) => {
    const isActive =
      sortConfig?.key === key && sortConfig?.isAscending === isAsc;
    return `cursor-pointer px-1 ${
      isActive ? "text-black font-bold" : "text-[#9E9E9E] hover:text-black"
    }`;
  };

  return (
    <div className="flex flex-row  w-full my-4 text-center text-[#9E9E9E] font-rubik font-light text-[16px] leading-tight tracking-wide-5 mx-auto ">
      <div className="w-[8%] flex justify-center items-center">
        <span
          className={getArrowClass("fromDate", true)}
          onClick={() => onFromDateClick(true)}
        >
          ▲
        </span>
        from
        <span
          className={getArrowClass("fromDate", false)}
          onClick={() => onFromDateClick(false)}
        >
          ▼
        </span>
      </div>
      <div className="w-[8%] flex justify-center items-center">
        <span
          className={getArrowClass("toDate", true)}
          onClick={() => onToDateClick(true)}
        >
          ▲
        </span>
        to
        <span
          className={getArrowClass("toDate", false)}
          onClick={() => onToDateClick(false)}
        >
          ▼
        </span>
      </div>
      <div className="w-[16%] ">team members</div>
      <div className="w-[25%] ">order</div>
      <div className="w-[32%] ">place</div>
      <div className="w-[11%] ">finish</div>
    </div>
  );
};